
import config from './config';
import styles from './styles';
import components from './components';

const professionalTheme = {
  config,
  styles,
  components
};

export default professionalTheme; 